import { useState } from "react";

interface Props {
  src?: string | null;
  alt?: string;
  className?: string;
}

export const CurrencyFlag = ({ src, alt = "", className = "h-5 w-5" }: Props) => {
  const [failed, setFailed] = useState(false);
  if (!src || failed) return null;
  return (
    <img
      src={src}
      alt={alt}
      onError={() => setFailed(true)}
      className={`inline-block flex-shrink-0 rounded-full object-cover ${className}`}
    />
  );
};

export default CurrencyFlag;
